<template>
  <v-input
    class="SelectButtonToggle__Input"
    :value="value"
    :rules="rules"
    :disabled="disabled"
    hide-details="auto"
  >
    <v-btn-toggle
      :value="value"
      @change="atualizarValor"
      :disabled="disabled"
      class="SelectButtonToggle custom-toggle"
      :mandatory="mandatory"
      rounded
      borderless
      dense
    >
      <v-btn
        v-for="option in options"
        :key="option.value"
        :value="option.value"
        class="SelectButtonToggle__Item"
        :class="
          value === option.value
            ? 'blue lighten-5 blue--text text--accent-4 font-weight-bold'
            : 'grey--text text--darken-2'
        "
        depressed
        small
      >
        {{ option.label }}
      </v-btn>
    </v-btn-toggle>
  </v-input>
</template>

<script>
export default {
  name: 'SelectButtonToggle',
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    mandatory: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    options: {
      handler() {
        this.definirPadraoSeVazio();
      },
      deep: true,
      immediate: true,
    },
    value: {
      handler() {
        this.definirPadraoSeVazio();
      },
      immediate: true,
    },
  },
  methods: {
    valorVazio(valor) {
      return valor === null || valor === undefined;
    },
    definirPadraoSeVazio() {
      if (!this.valorVazio(this.value)) {
        return;
      }

      if (!this.options || !this.options.length) {
        return;
      }

      const primeiraOpcao = this.options[0];
      if (!primeiraOpcao || primeiraOpcao.value === undefined) {
        return;
      }

      this.$nextTick(() => {
        if (this.valorVazio(this.value)) {
          this.$emit('input', primeiraOpcao.value);
        }
      });
    },
    atualizarValor(novoValor) {
      this.$emit('input', novoValor);
    },
  },
};
</script>

<style lang="scss">
.custom-toggle {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.SelectButtonToggle {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
}

.SelectButtonToggle .v-btn {
  border-radius: 999px !important;
  border: none !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  height: 36px !important;
  min-width: 96px !important;
  box-shadow: none !important;
  background: #f3f4f6 !important;
  color: rgba(33, 37, 41, 0.62) !important;
  padding: 0 16px;
}

.SelectButtonToggle .v-btn:not(:last-child) {
  margin-right: 8px !important;
}

.SelectButtonToggle .v-btn.v-btn--active {
  background: #e3f2fd !important;
  color: #1565c0 !important;
  font-weight: 700 !important;
}

.SelectButtonToggle .v-btn:not(.v-btn--active):hover {
  background: #eceff3 !important;
}

.SelectButtonToggle .v-btn.v-btn--disabled {
  opacity: 0.58;
}
</style>
